import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{yield\n  (hash mockFunction=this.mockFunction Item=(component \'styleguide/item\'))\n}}")